import { useState } from '@frontend/react';
import { BirthdayInputMask, Button, Text, YStack } from '@frontend/web-react';

import { PROFILE_WIZARD_STEP_CONFIGS } from '../ProfileWizardCard.constants';
import { PROFILE_WIZARD_STEP } from '../ProfileWizardCard.types';

const STEP_CONFIG = PROFILE_WIZARD_STEP_CONFIGS.find((c) => c.step === PROFILE_WIZARD_STEP.birthday)!;

type BirthdayStepProps = {
  initialValue: MaybeUndefined<DateISOString>;
  isSubmitting: boolean;
  onSubmit: (birthday: DateISOString) => void;
};

export const BirthdayStep = ({ initialValue, isSubmitting, onSubmit }: BirthdayStepProps) => {
  const [birthday, setBirthday] = useState<MaybeUndefined<DateISOString>>(initialValue);
  const isValid = Boolean(birthday && birthday.length === 10);

  return (
    <YStack gapY="md">
      <YStack gapY="xs">
        <Text type="h4">{STEP_CONFIG.title}</Text>
        <Text color="secondary" type="p-sm">
          {STEP_CONFIG.description}
        </Text>
      </YStack>
      <BirthdayInputMask label="" onChange={setBirthday} value={birthday} />
      <Button
        disabled={!isValid}
        fullWidth
        isLoading={isSubmitting}
        label={isValid ? 'Update' : 'Continue'}
        onClick={() => {
          if (birthday) {
            onSubmit(birthday);
          }
        }}
        size="lg"
        variant="primary"
      />
    </YStack>
  );
};
